import { injectable } from 'tsyringe'
import { BulletinApiRepository } from '@/app/repositories/api/BulletinApiRepository'
import { Bulletin } from '@/domain/entities/Bulletin'
import {
  PostBulletinInterface,
  DeleteBulletinInterface,
  UpdateBulletinInterface,
} from '@/data/payload/contracts/BulletinRequest'
@injectable()
export class BulletinPresenter {
  private repository: BulletinApiRepository

  constructor(repository: BulletinApiRepository) {
    this.repository = repository
  }

  public loadBulletin(params: Object): Promise<Bulletin> {
    return this.repository.getAll(params)
  }

  public postBulletin(payload: PostBulletinInterface): Promise<Bulletin> {
    return this.repository.post(payload)
  }

  public updateBulletin(
    payload: UpdateBulletinInterface,
    id: number
  ): Promise<Bulletin> {
    return this.repository.update(payload, id)
  }

  public deleteBulletin(payload: DeleteBulletinInterface): Promise<Bulletin> {
    return this.repository.delete(payload)
  }
}
